import React, { useEffect, useState } from 'react';
import ProjectsLayout from '../layouts/ProjectsLayout';
import ProjectsList from '../components/ProjectsList';
import ProjectModal from '../components/ProjectModal';

function ProjectsPage() {
  const [searchInput, setSearchInput] = useState('');
  const [search, setSearch] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);
  const [showArchivedProjects, setShowArchivedProjects] = useState(false);

  // debounce search input -> search
  useEffect(() => {
    const t = setTimeout(() => setSearch(searchInput), 350);
    return () => clearTimeout(t);
  }, [searchInput]);

  const handleAdd = () => {
    setEditItem(null);
    setShowModal(true);
  };

  const handleEdit = (item) => {
    setEditItem(item);
    setShowModal(true);
  };

  const handleSaved = () => {
    setShowModal(false);
    setEditItem(null);
    setReloadKey((k) => k + 1);
  };

  return (
    <ProjectsLayout title="Zagger">
      <section style={{ padding: '16px 24px 8px' }}>
        <div className="header-actions" style={{ marginBottom: 16, flexWrap: 'wrap', gap: 12, alignItems: 'center' }}>
          <div className="search-input-wrap">
            <i className="fas fa-search" aria-hidden="true"></i>
            <input
              type="text"
              className="projects-search-input"
              placeholder="Search projects..."
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
          </div>
          <label style={{ display: 'inline-flex', alignItems: 'center', gap: 8, cursor: 'pointer', userSelect: 'none', fontSize: 14, color: '#4b5563' }}>
            <input
              type="checkbox"
              checked={showArchivedProjects}
              onChange={(e) => setShowArchivedProjects(e.target.checked)}
            />
            Show archived projects
          </label>
          <button className="add-project-btn" onClick={handleAdd}>
            <i className="fas fa-plus-circle"></i>
            <span>New Project</span>
          </button>
        </div>
      </section>
      <section style={{ padding: '0 24px 32px' }}>
        <ProjectsList search={search} onEdit={handleEdit} reloadKey={reloadKey} showArchived={showArchivedProjects} />
      </section>
      {showModal && (
        <ProjectModal
          mode={editItem ? 'edit' : 'create'}
          initial={editItem || { name: '', description: '' }}
          onClose={() => { setShowModal(false); setEditItem(null); }}
          onSaved={handleSaved}
        />
      )}
    </ProjectsLayout>
  );
}

export default ProjectsPage;
